module.exports = __webpack_public_path__ + "static/media/podcast-loading.30f17ba8.gif";